import { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";

/**
 * Listen to broadcast actions from handlers
 * @param {string} action comma separated handler actions
 * @param {Function} callback with action, data, statusCode, errorCode
 * @returns null
 */
const useActionListener = (action, callback) => {

    const actionDetected = useSelector(state => {
                                                const actionArr = action?.replace(/ /g, "")?.split(",") || [];
                                                // Detect when the action is broadcasted in global state
                                                for (const key in state) {
                                                    if (actionArr.includes(state[key]?.notification?.action)){
                                                        const {action, data, statusCode, errorCode} = state[key]?.notification;
                                                        return [action, data, statusCode, errorCode];
                                                    }
                                                }
                                                return null;
                                            }, shallowEqual);
                                            
    useEffect(_ => {
        // Execute callback on action call
        if (actionDetected?.[0]){
            callback?.(...(actionDetected || []));
        }
    }, [callback, actionDetected])

    return null;
}

export default useActionListener;